







import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
export default class PageSection extends Vue {
    @Prop() private title!: string;
}
